function dismissTypeformSurvey() {
  const banner = $("#typeform-survey-banner");
  if (!banner.length) return;

  const typeformId = banner.attr("data-typeform-id");
  $.ajax({
    url: "/typeform_submissions",
    type: "POST",
    data: { typeform_id: typeformId },
    complete: () => banner.fadeOut(300, () => banner.remove())
  });
}

window.typeformSubmitHandler = dismissTypeformSurvey;

$(document).on('turbo:load', function() {
  $("#typeform-survey-banner .typeform-survey-dismiss").on("click", e => {
    e.preventDefault();
    dismissTypeformSurvey();
  });
});
